module.exports = __webpack_public_path__ + "assets/img/fix_open.be002e69.png";